import { render, staticRenderFns } from "./VueRecordVideo.vue?vue&type=template&id=1686f756&lang=html&"
import script from "./VueRecordVideo.vue?vue&type=script&lang=js&"
export * from "./VueRecordVideo.vue?vue&type=script&lang=js&"
import style0 from "./VueRecordVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports